import { IFormData } from "../components/formBuilder/formBuilder.entity";
import { setReducerState } from "../redux/crudSlice";
import { AppDispatch, store } from "../store/store";
import { ResponseArray, ResponseObject } from "./common.entity";
const { dispatch } = store

export const generateCodeNameList = (list: ResponseArray, codeKey: string = 'Code', nameKey: string = 'Name') => {
    if (!list?.length) return [];

    return list?.map(item => {
        let code = item[codeKey] ? `${item[codeKey]} - ` : ''
        let name = item[nameKey] || ''
        let codeName = code + name;
        return {
            ...item,
            Name: codeName
        }
    })
}


export const generateCodeName = (obj: ResponseObject, codeKey: string, nameKey: string): string => {
    let code = obj[codeKey] ? `${obj[codeKey]} - ` : ''
    let name = obj[nameKey] || ''
    return code + name;
}


export const generateFormFields = (formData: (IFormData | null)[]) => {
    let formFields: (IFormData | null)[] = [];
    formData?.forEach((field: any) => {
        if (Array.isArray(field?.value) && field?.value?.length) {
            formFields.push(...field?.value)
        }
        else if (field) formFields.push(field);
    })
    return formFields;
}


export const getUniqueRecords = (data: ResponseArray, key: string = 'id') => {
    if (!data?.length) return [];
    const uniqueRecords = [];
    const map = new Map();
    for (const item of data) {
        if (!map.has(item[key])) {
            map.set(item[key], true);
            uniqueRecords.push(item);
        }
    }
    return uniqueRecords;
};

export const sleep = (delay: number) => new Promise(res => setTimeout(res, delay));


export const cleanUpReducers = (keys: Array<string>) => {
    keys?.forEach((k: string) => dispatch(setReducerState({ key: k, value: null })));
}

export const arrayMapObj = (data: any, uniqueKey: string = 'id') => {
    let uniquePoints: Record<string, any> = {}
    data?.forEach((item: any) => {
        let key: string = item[uniqueKey];
        if (!uniquePoints[key]) {
            uniquePoints[key] = item;
        }
    });
    return uniquePoints;
}

export const formatTreeViewData =
    (
        data: ResponseArray = [],
        childrenKey: string = 'ChildName',
        labelKey: string = 'Name',
        filterItemBy: (item: ResponseObject, i?: number) => boolean = (item) => true,
        count: number = 0,
    ) => {
        if (data?.length === 0) return data;

        const treeData: ResponseArray = data.map(item => {
            const key = item[childrenKey];
            const children = item[key];
            let newItem: ResponseObject = {
                ...item,
                id: (item.id + count++),
                label: item[labelKey],
            };
            if (children?.length > 0) {
                newItem.children = formatTreeViewData(children, childrenKey, labelKey, filterItemBy, count);
            }
            return newItem;
        })

        return treeData.filter(filterItemBy);
    }

export const setDefaultProps = (props: ResponseObject, defaults: ResponseObject) => {
    Object.keys(defaults).forEach((k) => {
        if (props[k] === undefined) props[k] = defaults[k];
    })
}

export function moveItem(arr: Array<unknown>, fromIndex: number, toIndex: number) {
    const cutOut = arr.splice(fromIndex, 1)[0]; // Remove the element at fromIndex
    arr.splice(toIndex, 0, cutOut); // Insert it at toIndex
    return arr;
}

export const formatHeaderName = (name: string) => {
    return name.match(/[A-Z][a-z]+/g)?.join(' ');
}